<template>
  <div class="row">
    <div class="col-lg-12">
      <StatusModal :show.sync="modals.removeModal" :message="modal.remove" :title="modal.removeTitle" />
      <StatusModal :show.sync="modals.successModal" :message="modal.success" :title="modal.successTitle" />
      <div class="row">
        <div class="col-lg">
          <div class="scrollable-row">
            <div class="col-lg-4 d-flex">
              <card class="card-eprf">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  JOB DETAILS
                </p>
                <div style="height: 520px; overflow: scroll; overflow-x: hidden">
                  <p class="new-title">Job Reference No.</p>
                  <p class="subtitle">{{ jobno }}</p>

                  <p class="new-title">Collection Date</p>
                  <p class="subtitle">{{ collectiondate }}</p>

                  <p class="new-title">Service Location</p>
                  <p class="subtitle">
                    {{ servicelocation }}
                  </p>

                  <p class="new-title">Service Location Collection</p>
                  <p class="subtitle">{{ servicelocationcollection }}</p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Departure (ETD)
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ departureETD }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Previous Port
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ previousPort }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Next Port
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ nextPort }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Last Port & Date When Generated Waste Delivered
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ lastPortAndDate }}
                  </p>

                  <p class="new-title">Company Name</p>
                  <p class="subtitle">{{ companyName }}</p>

                  <p class="new-title">Company Address</p>
                  <p class="subtitle">{{ companyAddress }}</p>

                  <p class="new-title">Phone No. / Fax No.</p>
                  <p class="subtitle">{{ phoneNoFaxNo }}</p>

                  <p class="new-title">PIC Full Name</p>
                  <p class="subtitle">{{ picFullName }}</p>

                  <p class="new-title">PIC Phone No. / Fax No.</p>
                  <p class="subtitle">{{ picPhoneNoFaxNo }}</p>

                  <p class="new-title">PIC Email</p>
                  <p class="subtitle">{{ picEmail }}</p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Ship Name
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ shipName }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    IMO No.
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ imoNo }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Ship Type
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ shipType }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Gross Tonnage
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ grossTonnage }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Deadweight Tonnage (kg)
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ deadweightTonnage }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Owner / Operator Name
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ owneroperatorname }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Call Sign
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ callSign }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Flag State
                  </p>
                  <p class="subtitle">{{ flagState }}</p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Sustainable Certificates
                  </p>
                  <!-- <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ sustainableCertificates }}
                  </p> -->
                  <div v-if="landvesselflag == 'VESSEL' && shipdoc.length !== 0" v-for="(file, index) in shipdoc"
                :key="'allship_file' + index" class="row">
                <div class="col-lg-8">
                  {{ index + 1 }}.
                  <a :href="file.fileurl">
                    <base-button class="btn-link btn-primary">
                      {{ file.filename }}
                    </base-button>
                  </a>
                </div>
              </div>
              <p v-if="landvesselflag == 'VESSEL' && shipdoc.length === 0" class="subtitle">
                None
              </p>
                </div>
              </card>
            </div>
            <div v-if="generate == true" class="col-lg-4 d-flex">
              <card class="card-eprf">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  OPERATION PHOTOS
                </p>
                <div style="height: 520px; overflow: auto; overflow-x: hidden">
                  <div class="row" v-for="(card, index) in pics" :key="index">
                    <div class="col-lg">
                      <!-- <b-card
                        class="card"
                        border-variant="primary"
                        header="hi"
                        header-bg-variant="primary"
                        header-text-variant="white"
                        style="
                          box-shadow: 0px 0px;
                          border: none;
                          background-color: #f5f6fa;
                        "
                      > -->
                      <card class="card-eprf-with-header">
                        <!-- <template>
                          <div
                            slot="header"
                            style="font-size: 17px; color: #ffffff; height: 80%"
                          > -->
                        <div class="header" @click="openclose(index)">
                          <div class="row">
                            <div class="col-lg">
                              TRIP - {{ index + 1 }}
                            </div>
                            <div class="col-lg-3 text-right" v-if="card.flag == 'buka'">
                              <i @click="openclose(index)" class="tim-icons icon-minimal-down"></i>
                            </div>
                            <div class="col-lg-3 text-right" v-if="card.flag == 'tutup'">
                              <i @click="openclose(index)" class="tim-icons icon-minimal-right"></i>
                            </div>
                          </div>
                        </div>
                        <!-- </div>
                        </template> -->
                        <div class="body" v-if="card.flag == 'buka'">
                          <div class="row" style="line-height: 1px">
                            <div class="col-lg">
                              <p style="
                                text-align: left;
                                font-size: 17px;
                                color: #707070;
                                font-weight: 600;
                              ">
                                Full Side of RORO Bin
                              </p>
                            </div>
                          </div>

                          <div class="row" v-if="positionid != 4 && step < 6">
                            <div class="col-lg">
                              <p style="font-size: 14px; color: #aaaaaa">
                                Please upload related photo(s)
                              </p>
                            </div>
                          </div>

                          <div class="row" style="padding-bottom: 5px; padding-top: 5px">
                            <div class="col-lg-3" v-if="positionid != 4 && step < 6">
                              <label :for="index + 'fullside'">
                                <img src="@/assets/img/upload.png" width="73" height="45" />
                              </label>
                              <input accept="image/*" type="file" name="..." :id="index + 'fullside'" ref="fullside"
                                @change="onfullsidechange($event, index)" :multiple="true" style="display: none" />
                            </div>
                            <div class="col-lg-3" v-for="(item, index) in card.fullsideimages" :key="index">
                              <img :src="item.url" width="73" height="45" />
                              <div style="position: absolute; right: 20%; top: 0">
                                <base-button v-if="positionid != 4 && step < 6" class="btn-icon btn-cancel btn-round btn-xs" @click="
                                  deletefullsideimage(
                                    item.imageindex,
                                    item.imageid
                                  )
                                  "><i class="fa fa-times" aria-hidden="true"></i></base-button>
                                <br />

                                <a :href="item.url">
                                  <base-button class="btn-icon btn-primary btn-round btn-xs"><i class="fa fa-arrow-down"
                                      aria-hidden="true"></i></base-button>
                                </a>
                              </div>
                            </div>
                          </div>
                          <br />
                          <div class="row" style="line-height: 1px">
                            <div class="col-lg">
                              <p style="
                                text-align: left;
                                font-size: 17px;
                                color: #707070;
                                font-weight: 600;
                              ">
                                Inside of RORO Bin
                              </p>
                            </div>
                          </div>

                          <div class="row" v-if="positionid != 4 && step < 6">
                            <div class="col-lg">
                              <p style="font-size: 14px; color: #aaaaaa">
                                Please upload related photo(s)
                              </p>
                            </div>
                          </div>

                          <div class="row" style="padding-bottom: 5px; padding-top: 5px">
                            <div class="col-lg-3" v-if="positionid != 4 && step < 6">
                              <label :for="index + 'inside'">
                                <img src="@/assets/img/upload.png" width="73" height="45" />
                              </label>
                              <input accept="image/*" type="file" name="..." :id="index + 'inside'" ref="inside"
                                @change="oninsidechange($event, index)" :multiple="true" style="display: none" />
                            </div>
                            <div class="col-lg-3" v-for="(item, index) in card.insideimages" :key="index"
                              style="padding-bottom: 5px">
                              <img :src="item.url" width="73" height="45" />
                              <div style="position: absolute; right: 20%; top: 0">
                                <base-button v-if="positionid != 4 && step < 6" class="btn-icon btn-cancel btn-round btn-xs" @click="
                                  deleteinsideimage(
                                    item.imageindex,
                                    item.imageid
                                  )
                                  "><i class="fa fa-times" aria-hidden="true"></i></base-button>
                                <br />

                                <a :href="item.url">
                                  <base-button class="btn-icon btn-primary btn-round btn-xs"><i class="fa fa-arrow-down"
                                      aria-hidden="true"></i></base-button>
                                </a>
                              </div>
                            </div>
                          </div>
                          <br />
                          <div class="row" style="line-height: 1px">
                            <div class="col-lg">
                              <p style="
                                text-align: left;
                                font-size: 17px;
                                color: #707070;
                                font-weight: 600;
                              ">
                                Load of the Armroll
                              </p>
                            </div>
                          </div>

                          <div class="row" v-if="positionid != 4 && step < 6">
                            <div class="col-lg">
                              <p style="font-size: 14px; color: #aaaaaa">
                                Please upload related photo(s)
                              </p>
                            </div>
                          </div>

                          <div class="row" style="padding-bottom: 5px; padding-top: 5px">
                            <div class="col-lg-3" v-if="positionid != 4 && step < 6">
                              <label :for="index + 'armroll'">
                                <img src="@/assets/img/upload.png" width="73" height="45" />
                              </label>
                              <input accept="image/*" type="file" name="..." :id="index + 'armroll'" ref="armroll"
                                @change="onarmrollchange($event, index)" :multiple="true" style="display: none" />
                            </div>
                            <div class="col-lg-3" v-for="(item, index) in card.landarmrolls" :key="index"
                              style="padding-bottom: 5px">
                              <img :src="item.url" width="73" height="45" />
                              <div style="position: absolute; right: 20%; top: 0">
                                <base-button v-if="positionid != 4 && step < 6" class="btn-icon btn-cancel btn-round btn-xs" @click="
                                  deletearmrollimage(
                                    item.imageindex,
                                    item.imageid
                                  )
                                  "><i class="fa fa-times" aria-hidden="true"></i></base-button>
                                <br />

                                <a :href="item.url">
                                  <base-button class="btn-icon btn-primary btn-round btn-xs"><i class="fa fa-arrow-down"
                                      aria-hidden="true"></i></base-button>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </card>
                      <!-- </b-card> -->
                    </div>
                  </div>
                </div>
                <!-- <div class="row">
                  <div class="col-lg text-right">
                    <base-button class="btn-link" @click="addtrip()">
                      + Add trip</base-button
                    >
                  </div>
                </div> -->
              </card>
            </div>
            <div class="col-lg-4" v-if="generate == 'false'">
              <card style="
                  box-shadow: none;
                  padding: 0px 0px 30px 30px;
                  height: 630px;
                  background-color: white;
                ">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  PERMIT TO WORK (PTW)
                </p>
                <p class="new-title">PTW No.</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="ptwno" :class="{ 'custom-input': true }" />
                </div>
                <!-- <p class="sub-title">12089</p> -->

                <p class="new-title">Transporter</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="transporter" :class="{ 'custom-input': true }" />
                </div>

                <p class="new-title">DOE No.</p>
                <p class="subtitle">EIA TA/13</p>

                <p class="new-title">Company Address</p>
                <p class="subtitle">
                  Lot 42, Jalan Suria 5, Kajang, 43000 Selangor, Malaysia
                </p>

                <p class="new-title">Phone No. / Fax No.</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="phoneno" :class="{ 'custom-input': true }" />
                </div>
                <!-- <p class="sub-title">+60345625454</p> -->
              </card>
            </div>
            <div class="col-lg-8" v-if="generate == 'false'">
              <card class="card-eprf">
                <div class="row">
                  <div class="col-lg">
                    <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                      WASTE DETAILS
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg">
                    <!--   :cell-class-name="evenclass" -->
                    <el-table :data="wastedetails" :header-cell-style="{
                      background: '#358DCC',
                      border: 'transparent',
                      'font-size': '14px',
                      'font-weight': '400',
                      color: '#FFFFFF',
                    }" :cell-style="{ fontColor: '#707070' }" :row-style="tableRowClassName" style="color: #707070">
                      <el-table-column label="No." width="50" align="center">
                        <div slot-scope="scope">
                          <p style="color: #707070">{{ scope.$index + 1 }}</p>
                        </div>
                      </el-table-column>

                      <el-table-column label="Waste Type" prop="wastetype" width="160"></el-table-column>
                      <el-table-column label="Waste Qty." prop="wasteqty"></el-table-column>
                      <el-table-column label="Max Dedicated Storage Capacity" prop="maxdedicatedstoragecapacity"
                        width="170"></el-table-column>
                      <el-table-column label="Waste Amount Retained On-board" prop="wasteamountretainedonboard"
                        width="170"></el-table-column>
                      <el-table-column label="Remarks" prop="remarks"></el-table-column>
                    </el-table>
                  </div>
                </div>
              </card>
            </div>
            <!-- <div class="col-lg-4">
            <card
              style="box-shadow: none;
                padding: 0px 0px 30px 30px;
                height: 630px;
                background-color: white;
              "
            >
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                WASTE TO BE COLLECTED
              </p>
              <p class="new-title">Waste Type</p>
              <p class="subtitle">Annex I - Oily bilge water</p>
  
              <p class="new-title">Waste Quantity</p>
              <p class="subtitle">300 MT</p>
  
              <p class="new-title">Max Dedicated Storage Capacity</p>
              <p class="subtitle">500 MT</p>
  
              <p class="new-title">Amount of Waste Retained Onboard</p>
              <p class="subtitle">50 MT</p>
            </card>
          </div>
     
          <div class="col-lg-4">
            <card
              style="box-shadow: none;
                padding: 0px 0px 30px 30px;
                height: 630px;
                background-color: white;
              "
            >
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                CUSTOMER DETAILS
              </p>
              <p class="new-title">Customer Name</p>
              <p class="subtitle">Ombak Biru Holdings</p>
  
              <p class="new-title">Ship Name</p>
              <p class="subtitle">Eagle 01</p>
  
              <p class="new-title">PIC Full Name</p>
              <p class="subtitle">Amirah binti Azman</p>
  
              <p class="new-title">PIC Phone No. / Fax No.</p>
              <p class="subtitle">+60195627890</p>
  
              <p class="new-title">PIC Email</p>
              <p class="subtitle">amirah@ombakb.com.my</p>
            </card>
          </div> -->
            <div class="col-lg-4" v-if="generate == 'false'">
              <card style="
                  box-shadow: none;
                  padding: 0px 0px 30px 30px;
                  height: 630px;
                  background-color: white;
                ">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  TRANSPORTER DETAILS
                </p>
                <p class="new-title">Transporter Name</p>
                <p class="subtitle">Berjaya Waste Sdn Bhd</p>

                <p class="new-title">PIC Full Name</p>
                <p class="subtitle">Nick Chan</p>

                <p class="new-title">Phone No. / Fax No.</p>
                <p class="subtitle">+60129923290</p>

                <p class="new-title">Vehicle Registration No.</p>
                <p class="subtitle">BGK 8080</p>
              </card>
            </div>
            <div class="col-lg-4" v-if="generate == 'false'">
              <card style="
                  box-shadow: none;
                  color: #A5A5A5;
                  padding: 0px 0px 30px 30px;
                  height: 630px;
                  background-color: white;
                ">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  CHECKLIST
                </p>
                <p class="new-title">Facility Type</p>
                <input type="checkbox" class="rounded-checkbox" id="checkbox" v-model="checkedItems"
                  :value="selectall[0].value" />&nbsp;&nbsp;{{ selectall[0].label }}
                <div style="
                    padding-top: 10px;
                    margin-bottom: 5px;
                    width: 80%;
                    border-bottom: 1px solid lightgray;
                  "></div>
                <div>
                  <div style="line-height: 0.7cm" v-for="(file, index) in facilitytypes" :key="index">
                    <input type="checkbox" class="rounded-checkbox" id="checkbox" v-model="checkedItems"
                      :value="facilitytypes[index].value" />&nbsp;&nbsp;{{ facilitytypes[index].label }}
                  </div>
                  <div v-if="checkedItems.includes(14)">
                    <div style="padding-right: 30px">
                      <input type="text" v-model="specifies" :class="{ 'custom-input': true }" />
                    </div>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg text-right">
          <base-button wide type="danger" @click.native="prevTab" class="btn-previous">
            BACK
          </base-button>
          <base-button type="primary" wide @click.native="nextTab" class="btn-next" :disabled="nextbtn">
            NEXT
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";
import swal from "sweetalert2";
import { ImageUpload, Modal } from "src/components";
import { Circle8 } from "vue-loading-spinner";
import moment from "moment";
import { BCard } from "bootstrap-vue";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";

export default {
  props: ["parentData"],
  components: {
    StatusModal,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    Circle8,
    BCard,
    Modal,
  },
  props: ["test1"],
  data() {
    return {
      nextbtn: true,
      modal: modal,
      modals: {
        successModal: false,
        removeModal: false,
      },
      message: "",
      pics: [
        {
          fullsideimages: [
            // {
            //   url: require("@/assets/img/upload.png"),
            // },
            // {
            //   url: require("@/assets/img/upload.png"),
            // },
            // {
            //   url: require("@/assets/img/upload.png"),
            // },
            // {
            //   url: require("@/assets/img/upload.png"),
            // },
            // {
            //   url: require("@/assets/img/upload.png"),
            // },
          ],
          insideimages: [],
          landarmrolls: [],
        },
      ],
      disablebtn: false,
      allfilePTWname: [],
      jobno: "",
      arrivalETA: "18 Nov 2022",
      collectiondate: "",
      servicelocation: "",
      servicelocationcollection: "",
      departureETD: "15 Nov 2022",
      previousPort: "None",
      nextPort: "None",
      lastPortAndDate: "None",
      companyName: "Ombak Biru Holdings",
      companyAddress: "Coplace 2, Switzeeerrrrrss",
      phoneNoFaxNo: "08-98989989",
      picFullName: "Wahab bin Wahab",
      picPhoneNoFaxNo: "012-3569488",
      picEmail: "wahab@sendirianberhad.com",
      shipName: "Tiger Wave",
      imoNo: "8804275",
      shipType: "Ikan bilis tanker",
      grossTonnage: "220000",
      deadweightTonnage: "10000",
      owneroperatorname: "Abu bin Seman",
      callSign: "Bilis dot com",
      flagState: "Malaysia",
      sustainableCertificates: "1 - ISO 14001.pdf",
      shipdoc: [],

      wastedetails: [
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
      ],

      generate: true,
      selectedFileNamePTW: "",
      allfilenamePTW: [],
      docsPTW: "",
      documentPTW: 0,
      documentIDPTW: [],
      uploadloadPTW: false,

      scroll: false,
      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },

      checkedItems: [],

      selectall: [{ value: 0, label: "Select all" }],

      facilitytypes: [
        { value: 1, label: "Terminal approval" },
        { value: 2, label: "Safety helmet" },
        { value: 3, label: "Life jacket" },
        { value: 4, label: "Hand glove" },
        { value: 5, label: "Safety shoes" },
        { value: 6, label: "Safety vase" },
        { value: 7, label: "Fire extinguisher" },
        { value: 8, label: "Oil boom" },
        { value: 9, label: "Signage" },
        { value: 10, label: "Lorry choke" },
        { value: 11, label: "Oil dip tray" },
        { value: 12, label: "Bariccade" },
        { value: 13, label: "SOPEP equipment" },
        { value: 14, label: "Other (specify):" },
      ],

      specifies: "",

      ptwno: "12089",
      transporter: "Transporter A",
      deliveryterm: "",
      paymentterm: "",
      phoneno: "+60345625454",

      selects: {
        date: "",

        transporter: "",
        transporters: [
          { value: "1", label: "Ikhlas Waste Sdn Bhd" },
          { value: "2", label: "Berjaya Waste Sdn Bhd" },
          { value: "3", label: "Gemilang Waste Holdings" },
        ],
      },
      landvesselflag: "",
      positionid: "",
    };
  },
  created() {
    this.jobno = this.$route.params.jobnum.split("_")[0];
    this.getDetail();
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
  },
  mounted() { },
  methods: {
    openclose(index) {
      if (this.pics[index].flag == "tutup") {
        this.pics[index].flag = "buka"
      } else {
        this.pics[index].flag = "tutup"
      }

      sessionStorage.setItem("scrap" + index, this.pics[index].flag)
      // console.log(sessionStorage.getItem("scrap" + index))
      // this.pics[index].flag = flag 
      // 
    },
    deletearmrollimage(index, imageid) {
      console.log(imageid);

      this.$http
        .delete(
          ":10001/api/v1/incoming/scrap/" +
          this.jobno +
          "/trip/dashboard/load/" +
          index +
          "/" +
          imageid
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.message = response;
            this.modals.removeModal = true;

            this.getDetail();
          }
        });
    },
    deleteinsideimage(index, imageid) {
      this.$http
        .delete(
          ":10001/api/v1/incoming/scrap/" +
          this.jobno +
          "/trip/dashboard/inside/" +
          index +
          "/" +
          imageid
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.message = response;
            this.modals.removeModal = true;

            this.getDetail();
          }
        });
    },
    deletefullsideimage(index, imageid) {
      this.$http
        .delete(
          ":10001/api/v1/incoming/scrap/" +
          this.jobno +
          "/trip/dashboard/full-side/" +
          index +
          "/" +
          imageid
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.message = response;
            this.modals.removeModal = true;

            this.getDetail();
          }
        });
    },
    addtrip() {
      this.pics.push({
        fullsideimages: [
          {
            url: null,
            //   require("@/assets/img/upload.png"),
          },
        ],
      });
    },
    onfullsidechange(e, index) {
      const t = e.target;
      const formData = new FormData();


      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("images", o);
      }

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }
      this.$http
        .post(
          ":10001/api/v1/incoming/scrap/" +
          this.jobno +
          "/trip/dashboard/full-side/" +
          index,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
            this.getDetail();

            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            // this.getDetail();
          }
        });
      //   }
    },
    onarmrollchange(e, index) {
      const t = e.target;
      const formData = new FormData();
      console.log(t.files[0]);

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("images", o);
      }

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }
      this.$http
        .post(
          ":10001/api/v1/incoming/scrap/" +
          this.jobno +
          "/trip/dashboard/load/" +
          index,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
            this.getDetail();

            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            // this.getDetail();
          }
        });
    },
    oninsidechange(e, index) {
      const t = e.target;
      const formData = new FormData();
      console.log(t.files[0]);

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("images", o);
      }

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }
      this.$http
        .post(
          ":10001/api/v1/incoming/scrap/" +
          this.jobno +
          "/trip/dashboard/inside/" +
          index,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
            this.getDetail();

            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            // this.getDetail();
          }
        });

      //   }
    },
    getDetail() {
      this.allfilePTWname = [];
      this.fullsideimages = [];
      this.pics = [];
      this.shipdoc = [];

      this.$http
        .get(":10001/api/v1/incoming/scrap/" + this.jobno)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            if (typeof response.dashboard_step == 'string') {
              this.step = Number(response.dashboard_step)
            } else if (typeof response.dashboard_step == 'number') {
              this.step = response.dashboard_step;
            } else {
              this.step = response.dashboard_step;
            }
            this.collectiondate = moment(response.collection_date).format(
              "YYYY-MM-DD"
            );
            this.servicelocation = response.service_location.service_location;
            this.servicelocationcollection =
              response.service_location.collection_location;
            this.companyName = response.company.company_name;
            this.companyAddress = response.company.company_address;

            this.phoneNoFaxNo =
              (response.company.company_phone_number == "" ||
                response.company.company_phone_number == null
                ? "N/A"
                : response.company.company_phone_number) +
              " / " +
              (response.company.company_fax_number == "" ||
                response.company.company_fax_number == null
                ? "N/A"
                : response.company.company_fax_number);
            this.picFullName = response.pic.pic_name;
            this.picPhoneNoFaxNo =
              (response.pic.pic_phone_number == "" ||
                response.pic.pic_phone_number == null
                ? "N/A"
                : response.pic.pic_phone_number) +
              " / " +
              (response.pic.pic_fax_number == "" ||
                response.pic.pic_fax_number == null
                ? "N/A"
                : response.pic.pic_fax_number);

            this.picEmail = response.pic.pic_email;

            // get all ptw
            if (response.ptw_document != null) {
              // for (var i = 0; i < response.ptw_document.length; i++) {
              let obj = {
                filename: response.ptw_document.meta.filename,
                fileurl: response.ptw_document.url,
                fileid: response.ptw_document.ptw_document_id,
              };
              this.allfilePTWname.push(obj);
              // }
            }

            //bukan ship
            // if (response.ship.documents != null) {
            // for (var i = 0; i < response.ship.documents.length; i++) {
            //   let obj = {
            //     filename: response.ship.documents[i].meta.filename,
            //     fileid: response.ship.documents[i].ship_document_id,
            //     fileurl: response.ship.documents[i].url,
            //   };
            //   this.shipdoc.push(obj);
            // }
          // }

            // get operation image
            if (response.trip_0 !== null) {
              const fullsideimages = response.trip_0.full_side_image.map((image) => ({ url: image.url, imageid: image.image_id, imageindex: 1 }))
              const insideimages = response.trip_0.inside_image.map((image) => ({ url: image.url, imageid: image.image_id, imageindex: 1 }))
              const landarmrolls = response.trip_0.load_image.map((image) => ({ url: image.url, imageid: image.image_id, imageindex: 1 }))

              this.pics.push({
                fullsideimages: fullsideimages,
                insideimages: insideimages,
                landarmrolls: landarmrolls,
                flag: sessionStorage.getItem("scrap" + 0) == undefined ? "tutup" : sessionStorage.getItem("scrap" + 0).toString(),
              });
              if (
                response.dashboard_step > 3 ||
                (fullsideimages.length !== 0 && insideimages.length !== 0 && landarmrolls.length !== 0)
              ) this.nextbtn = false
            } else if (response.trip.length > 0) {
              this.nextbtn = false
              response.trip.forEach((trip, i) => {
                const fullsideimages = trip.full_side_image.map((image) => ({ url: image.url, imageid: image.image_id, imageindex: trip.trip_index }))
                const insideimages = trip.inside_image.map((image) => ({ url: image.url, imageid: image.image_id, imageindex: trip.trip_index }))
                const landarmrolls = trip.load_image.map((image) => ({ url: image.url, imageid: image.image_id, imageindex: trip.trip_index }))

                this.pics.push({
                  fullsideimages: fullsideimages,
                  insideimages: insideimages,
                  landarmrolls: landarmrolls,
                  flag: sessionStorage.getItem("scrap" + i) == undefined ? "tutup" : sessionStorage.getItem("scrap" + i).toString(),
                });

                if (response.dashboard_step > 3) this.nextbtn = false
                else if (this.nextbtn === false) this.nextbtn = (fullsideimages.length === 0 || insideimages.length === 0 || landarmrolls.length === 0)
              })
              this.nextbtn = !((response.dashboard_step > 3) || (!this.nextbtn))
            } else {
              this.pics.push({
                flag: "tutup",
                fullsideimages: [],
                insideimages: [],
                landarmrolls: [],
              });
            }
          }
        });
    },
    nextTab() {
      let parameter = {
        step: "3",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    prevTab() {
      let parameter = {
        step: "3",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },
    onFileChangePTW(event) {
      console.log("___________ hoy_________________");
      if (this.allfilePTWname.length == 0) {
        this.docsPTW = this.$refs.ptwfile.files[0];

        this.selectedFileNamePTW = this.$refs.ptwfile.files[0].name;
        this.allfilenamePTW.push(this.selectedFileNamePTW);

        const formData = new FormData();
        formData.append("document", this.docsPTW);

        // to verify form data
        for (var pair of formData.entries()) {
          console.log(pair);
        }

        this.uploadloadPTW = true;

        this.$http
          .post(
            ":10001/api/v1/incoming/scrap/" + this.jobno + "/ptw",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + sessionStorage.getItem("token"),
              },
            }
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              swal({
                title: `Success!`,
                text: response,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-primary btn-fill",
                type: "success",
              });
              this.getDetail();
              this.uploadloadPTW = false;
            }
          });
      } else {
        swal({
          title: `Info!`,
          text: "Only 1 file allowed to be uploaded",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary btn-fill",
          type: "info",
        });
      }
    },
    removeFile(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this action!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(":10001/api/v1/incoming/scrap/" + this.jobno + "/ptw")
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                swal({
                  title: `Success!`,
                  text: response,
                  buttonsStyling: false,
                  confirmButtonClass: "btn btn-primary btn-fill",
                  type: "success",
                });
                this.getDetail();
              }
            });
        }
      });
    },
    getScroll() {
      this.scroll = true;
    },
    getScroll2() {
      this.scroll = false;
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$root.$emit("image", this.imagebase64);
        return res;
      });
    },
  },
  watch: {

    // allfilePTWname: {
    //   handler: function (val, oldVal) {
    //     if (this.allfilePTWname.length != 0) {
    //       this.disablebtn = false;
    //     } else {
    //       this.disablebtn = true;
    //     }
    //   },
    //   deep: true,
    // },
  },
};
</script>
<style scoped>
textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
  /* color: #1d253b; */
}

textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}

.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.sub-title {
  text-decoration: underline;
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.scrollable {
  height: 500px;
  overflow-y: scroll;
  padding: 0px 0px 0px 30px;
  color: #A5A5A5;
}

.newtitle {
  color: #707070;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.sub-titles {
  margin-top: -5px;
  color: #A5A5A5;
}

/* Styles for individual buttons */
.left-button,
.right-button {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #358CCB;
  /* You can change the color as desired */
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
}

.scrollable-row {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-bottom: 15px;
  /* Adjust as needed */
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}
</style>
